// src/components/ImprovedNavigation.js
import React from 'react';
import { useAppContext } from '../context/AppContext';

function ImprovedNavigation() {
  const { currentView, setCurrentView } = useAppContext();

  const navItems = [
    { id: 'generator', label: 'Workout Generator', icon: '💪', description: 'Create custom workouts' },
    { id: 'programs', label: 'Programs', icon: '🏆', description: 'View structured workout programs' },
    { id: 'progress', label: 'Progress', icon: '📊', description: 'Track your workout history' },
    { id: 'exercises', label: 'Exercise Library', icon: '📚', description: 'Browse all exercises' },
    { id: 'favorites', label: 'Favorites', icon: '❤️', description: 'View saved exercises' },
  ];

  return (
    <nav className="w-full" aria-label="Main navigation">
      {/* Desktop Navigation */}
      <div className="hidden md:flex justify-between" role="tablist">
        {navItems.map(item => (
          <button
            key={item.id}
            onClick={() => setCurrentView(item.id)}
            className={`flex items-center px-4 py-2 font-medium text-sm rounded-md transition-all duration-200 ${
              currentView === item.id
                ? 'text-blue-700 bg-blue-100 shadow-sm'
                : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50'
            }`}
            role="tab"
            aria-selected={currentView === item.id}
            aria-controls={`${item.id}-panel`}
            id={`${item.id}-tab`}
          >
            <span className="mr-2" aria-hidden="true">{item.icon}</span>
            {item.label}
          </button>
        ))}
      </div>

      {/* Mobile Navigation - Bottom Tab Bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 px-2 pb-safe-area">
        <div className="flex justify-between py-2" role="tablist" aria-label="Navigation tabs">
          {navItems.map(item => (
            <button
              key={item.id}
              onClick={() => setCurrentView(item.id)}
              className={`flex flex-col items-center justify-center w-full py-1 px-1 rounded-md transition-colors ${
                currentView === item.id
                  ? 'text-blue-600 bg-blue-50'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
              role="tab"
              aria-selected={currentView === item.id}
              aria-controls={`${item.id}-panel`}
              id={`${item.id}-tab-mobile`}
              aria-label={`${item.label}: ${item.description}`}
            >
              <span className="text-xl mb-1" aria-hidden="true">{item.icon}</span>
              <span className="text-xs whitespace-nowrap">{item.label}</span>
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
}

export default ImprovedNavigation;